interface IProps {
	children: React.ReactNode;
	borderCustom?: boolean;
}

export const BaskteballField = ({ children, borderCustom }: IProps) => {
	const borderColor = borderCustom ? 'border-[#aeaeae]' : 'border-[#707070]';

	return (
		<div
			className={`relative w-full border-2 ${borderColor} rounded-lg bg-soccerfield bg-contain py-4 h-[280px]`}
		>
			<div className="absolute inset-0 pointer-events-none">
				<div className="flex h-full flex-col justify-between items-center">
					<div className="flex flex-col items-center">
						<div
							className={`w-80 h-40 border-2 relative flex flex-col justify-between items-center -top-0.5 rounded-b-full ${borderColor}`}
						>
							<div
								className={`w-20 h-[121px] border-2 relative flex-col justify-end items-center -top-0.5 ${borderColor} flex`}
							>
								<div
									className={`w-20 h-20 border-2 absolute -bottom-10 rounded-full ${borderColor}`}
									style={{
										clipPath: 'inset(50% 0 0 0)',
									}}
								/>
								<div
									className={`w-20 h-20 border-2 border-dashed absolute -bottom-10 rounded-full ${borderColor}`}
									style={{
										clipPath: 'inset(0 0 50% 0)',
									}}
								/>
								<div
									className={`w-full h-[1px] bottom-14 border-t-2 border-dashed relative ${borderColor}`}
								/>
							</div>
						</div>
					</div>
					<div className="flex flex-col items-center rotate-180">
						<div data-svg-wrapper className="relative -top-0.5">
							<svg
								width="96"
								height="31"
								viewBox="0 0 96 31"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<mask id="path-1-inside-1_2_13396" fill="white">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M0.186707 0.0664062C8.33332 18.2559 26.5939 30.9277 47.8143 30.9277C69.0346 30.9277 87.2952 18.2559 95.4418 0.0664062H0.186707Z"
									/>
								</mask>
								<path
									d="M0.186707 0.0664062V-2.10693H-3.16803L-1.79678 0.95476L0.186707 0.0664062ZM95.4418 0.0664062L97.4253 0.95476L98.7965 -2.10693H95.4418V0.0664062ZM47.8143 28.7544C27.4815 28.7544 9.97947 16.6143 2.17019 -0.821948L-1.79678 0.95476C6.68717 19.8974 25.7064 33.1011 47.8143 33.1011V28.7544ZM93.4583 -0.821948C85.649 16.6143 68.147 28.7544 47.8143 28.7544V33.1011C69.9221 33.1011 88.9413 19.8974 97.4253 0.95476L93.4583 -0.821948ZM95.4418 -2.10693H0.186707V2.23974H95.4418V-2.10693Z"
									fill={borderCustom ? '#aeaeae]' : '#707070'}
									mask="url(#path-1-inside-1_2_13396)"
								/>
							</svg>
						</div>
					</div>
				</div>
			</div>
			{children}
		</div>
	);
};
